import { isAddress } from 'ethers/lib/utils';
import { IUniswapV3LeverageDataProvider__factory } from './typechain/IUniswapV3LeverageDataProvider__factory';
export class UniswapV3LeverageDataProvider {
    // private readonly chainId: number;
    /**
     * Constructor
     * @param context The ui pool data provider context
     */
    constructor(context) {
        if (!isAddress(context.uniswapV3LeverageDataProviderAddress)) {
            throw new Error('contract address is not valid');
        }
        this._contract = IUniswapV3LeverageDataProvider__factory.connect(context.uniswapV3LeverageDataProviderAddress, context.provider);
        // this.chainId = context.chainId;
    }
    async getPositionsData({ addresses, }) {
        return this._contract.getPositionsData(addresses);
    }
    async getGlobalRevenueFee() {
        return this._contract.getGlobalRevenueFee();
    }
}
//# sourceMappingURL=index.js.map